const SurahReader = [
  {
    identifier: "ar.abdulazizazzahrani",
    name: "عبد العزيز الزهراني",
    englishName: "Abdulaziz Az-Zahrani",
  },
  {
    identifier: "ar.abdulbariaththubaity",
    name: "عبد الباري الثبيتي",
    englishName: "AbdulBari ath-Thubaity",
  },
  {
    identifier: "ar.abdulbarimohammed",
    name: "عبد الباري محمد",
    englishName: "Abdul Bari Mohammed",
  },
  {
    identifier: "ar.abdulbasitmujawwad",
    name: "عبد الباسط عبد الصمد (مجود)",
    englishName: "AbdulBaset AbdulSamad [Mujawwad]",
  },
  {
    identifier: "ar.abdulbasitmurattal",
    name: "عبد الباسط عبد الصمد (مرتل)",
    englishName: "AbdulBaset AbdulSamad [Murattal]",
  },
  {
    identifier: "ar.abdulkareemalhazmi",
    name: "عبد الكريم الحازمي",
    englishName: "Abdul-Kareem al-Hazmi",
  },
  {
    identifier: "ar.abdullahalmatrood",
    name: "عبد الله المطرود",
    englishName: "Abdullah al-Matrood",
  },
  {
    identifier: "ar.abdullahawadaljuhani",
    name: "عبد الله الجهني",
    englishName: "Abdullah Juhany",
  },
  {
    identifier: "ar.abdullahbasfar",
    name: "عبد الله بصفر",
    englishName: "Abdullah Basfar",
  },
  {
    identifier: "ar.abdullahkhayat",
    name: "عبد الله خياط",
    englishName: "Abdullah Khayat",
  },
  {
    identifier: "ar.abdullahkhulaifi",
    name: "عبد الله خليفة",
    englishName: "Abdullah Khulayfee",
  },
  {
    identifier: "ar.abdulmohsenalharthy",
    name: "عبد المحسن الحارثي",
    englishName: "Abdulmohsen Al-Harthy",
  },
  {
    identifier: "ar.abdulmuhsinalqasim",
    name: "عبد المحسن القاسم",
    englishName: "AbdulMuhsin al-Qasim",
  },
  {
    identifier: "ar.abdulmunimabdulmubdi",
    name: "عبد المنعم عبد المبديع",
    englishName: "Abdul-Mun'im Abdul-Mubdi'",
  },
  {
    identifier: "ar.abdulwadoodhaneef",
    name: "عبد الودود حنيف",
    englishName: "AbdulWadood Haneef",
  },
  {
    identifier: "ar.abdurrasheedsufiabialhaarithanalkasaaee",
    name: "عبد الرشيد صوفي [أبي الحارث الكسائي]",
    englishName: "Abdur-Rashid Sufi [Abi al-Haarith an al-Kasaa’ee]",
  },
  {
    identifier: "ar.abdurrasheedsufiaddoorianabiamr",
    name: "عبد الرشيد صوفي [الدوري عن أبي عمرو]",
    englishName: "Abdur-Rashid Sufi [ad-Doori an Abi Amr]",
  },
  {
    identifier: "ar.abdurrasheedsufishubahanasim",
    name: "عبد الرشيد صوفي [شعبة عن عاصم]",
    englishName: "Abdur-Rashid Sufi [Shu'bah an Asim]",
  },
  {
    identifier: "ar.abdurrasheedsufisoosi",
    name: "عبد الرشيد صوفي [السوسي]",
    englishName: "Abdurrashid Sufi [Soosi]",
  },
  {
    identifier: "ar.abdurrazaqbinabtanaldulaimi",
    name: "عبد الرزاق بن أبطان الدليمي",
    englishName: "Abdur Razaq Bin Abtan Al Dulaimi",
  },
  {
    identifier: "ar.abuabdullahmuniraltounsi",
    name: "أبو عبد الله منير الطونسي",
    englishName: "Abu Abdullah Munir Al Tounsi",
  },
  {
    identifier: "ar.abubakraldhabi",
    name: "أبو بكر الظبي",
    englishName: "Abu Bakr al Dhabi",
  },
  {
    identifier: "ar.adilkalbani",
    name: "عادل كلباني",
    englishName: "Adel Kalbani",
  },
  {
    identifier: "ar.ahmadalhawashy",
    name: "أحمد الحواشي",
    englishName: "Ahmad Al Hawashy",
  },

  {
    identifier: "ar.ahmadalnufais",
    name: "أحمد النفيس",
    englishName: "Ahmad Alnufais",
  },

  {
    identifier: "ar.ahmadkhaderaltarabulsi",
    name: "أحمد خضر الطرابلسي",
    englishName: "Ahmad Khader Al-Tarabulsi",
  },

  {
    identifier: "ar.ahmadsulaiman",
    name: "أحمد سليمان",
    englishName: "Ahmad Suleiman",
  },

  {
    identifier: "ar.ahmedalajmi",
    name: "أحمد بن علي العجمي",
    englishName: "Ahmed ibn Ali al-Ajamy",
  },

  {
    identifier: "ar.ahmedalhammad",
    name: "أحمد الحماد",
    englishName: "Ahmed Al Hammad",
  },

  {
    identifier: "ar.ahmedalmisbahi",
    name: "أحمد المصباحي",
    englishName: "Ahmed Al Misbahi",
  },

  {
    identifier: "ar.ahmedamir",
    name: "أحمد أمير",
    englishName: "Ahmed Amir",
  },

  {
    identifier: "ar.ahmedmohamedsalama",
    name: "أحمد محمد سلامة",
    englishName: "Ahmed Mohamed Salama",
  },

  {
    identifier: "ar.ahmedsaber",
    name: "أحمد صابر",
    englishName: "Ahmed Saber",
  },

  {
    identifier: "ar.alafasy",
    name: "مشاري راشد العفاسي",
    englishName: "Mishary Rashid Alafasy",
  },

  {
    identifier: "ar.alashryomran",
    name: "العشري عمران",
    englishName: "Al Ashry Omran",
  },

  {
    identifier: "ar.alfatehmuhammadzubair",
    name: "الفاتح محمد زبير",
    englishName: "Al Fateh Muhammad Zubair",
  },

  {
    identifier: "ar.alhusaynialazazi",
    name: "الحسيني العزازي",
    englishName: "Al Husayni Al Azazi",
  },

  {
    identifier: "ar.alhusaynialazazichildren",
    name: "الحسيني العزازي - أطفال",
    englishName: "Al Husayni Al Azazi - Children",
  },

  {
    identifier: "ar.aliabdurrahmanalhuthaify",
    name: "علي عبد الرحمن الحذيفي",
    englishName: "Ali Abdur-Rahman al-Huthaify",
  },

  {
    identifier: "ar.aliabdurrahmanalhuthaifyqaloon",
    name: "علي الحذيفي [قالون]",
    englishName: "Ali al-Huthaify [Qaaloon]",
  },

  {
    identifier: "ar.alihajjajsouissi",
    name: "علي حجاج سويسي",
    englishName: "Ali Hajjaj Souissi",
  },

  {
    identifier: "ar.alzainmohamedahmed",
    name: "الزين محمد أحمد",
    englishName: "Alzain Mohammad Ahmad",
  },

  {
    identifier: "ar.aymanswed",
    name: "أيمن سويد",
    englishName: "Ayman Swed",
  },

  {
    identifier: "ar.azizalili",
    name: "عزيز العلي",
    englishName: "Aziz Alili",
  },

  {
    identifier: "ar.bandarbalila",
    name: "بندر بليلة",
    englishName: "Bandar Balila",
  },

  {
    identifier: "ar.basselabdulrahmanraoui",
    name: "باسل عبد الرحمن راوي",
    englishName: "Bassel Abdul Rahman Raoui",
  },

  {
    identifier: "ar.benkirane",
    name: "عبد المجيب بن كيران",
    englishName: "عبد المجيب بن كيران",
  },

  {
    identifier: "ar.darwishfarajdarwishalattar",
    name: "درويش فرج درويش العطار",
    englishName: "Darwish Faraj Darwish Al Attar",
  },

  {
    identifier: "ar.eidhassanabuaachra",
    name: "عيد حسن أبو عشرة",
    englishName: "Eid Hassan Abu Aachra",
  },
  {
    identifier: "ar.emadalmansary",
    name: "عماد المنصري",
    englishName: "Emad Al Mansary",
  },
  {
    identifier: "ar.ezzatsabri",
    name: "عزت صبري",
    englishName: "Ezzat Sabri",
  },
  {
    identifier: "ar.faresabbad",
    name: "فارس عباد",
    englishName: "Fares Abbad",
  },
  {
    identifier: "ar.fouadalkhamiri",
    name: "فؤاد الخامري",
    englishName: "Fouad Al Khamiri",
  },
  {
    identifier: "ar.hamadsinan",
    name: "حمد سنان",
    englishName: "Hamad Sinan",
  },
  {
    identifier: "ar.hamdyalsayedtolbasaad",
    name: "حمدي السيد طلبة سعد",
    englishName: "Hamdy Al Sayed Tolba Saad",
  },
  {
    identifier: "ar.haniarrifai",
    name: "هاني الرفاعي",
    englishName: "Hani ar-Rifai",
  },
  {
    identifier: "ar.hasanhashem",
    name: "حسن هاشم",
    englishName: "Hasan Hashem",
  },
  {
    identifier: "ar.hassansaleh",
    name: "حسن صالح",
    englishName: "Hasan Saleh",
  },
  {
    identifier: "ar.hatemfarid",
    name: "حاتم فريد",
    englishName: "hatemfarid",
  },
  {
    identifier: "ar.ibrahimalakhdar",
    name: "ابراهيم الاخضر",
    englishName: "Ibrahim Al Akhdar",
  },
  {
    identifier: "ar.ibrahimaldossari",
    name: "ابراهيم الدسيري",
    englishName: "Ibrahim Al Dossari",
  },
  {
    identifier: "ar.ibrahimaljormy",
    name: "ابراهيم الجرمي",
    englishName: "Ibrahim Aljormy",
  },
  {
    identifier: "ar.ilhantok",
    name: "إلهان توك",
    englishName: "Ilhan Tok",
  },
  {
    identifier: "ar.imadzuhairhafez",
    name: "عماد زهير حافظ",
    englishName: "Imad Zuhair Hafez",
  },
  {
    identifier: "ar.jaberabdulhameed",
    name: "جابر عبد الحميد",
    englishName: "Jaber Abdul Hameed",
  },
  {
    identifier: "ar.jamaanalosaimi",
    name: "جمعان العصيمي",
    englishName: "Jamaan Alosaimi",
  },
  {
    identifier: "ar.jamalshakerabdullah",
    name: "جمال شاكر عبد الله",
    englishName: "Jamal Shaker Abdullah",
  },
  {
    identifier: "ar.jazzaalswaileh",
    name: "جزاء الصويلح",
    englishName: "Jazza Alswaileh",
  },
  {
    identifier: "ar.kamel",
    name: "عبد الله كامل",
    englishName: "Abdallah Kamel",
  },
  {
    identifier: "ar.karimmansouri",
    name: "كريم منصوري",
    englishName: "Karim Mansouri",
  },
  {
    identifier: "ar.khaledalqahtani",
    name: "خالد عبد الله القحطاني",
    englishName: "Khaalid Abdullaah al-Qahtaanee",
  },
  {
    identifier: "ar.khaledbarakat",
    name: "خالد بركات",
    englishName: "Khaled Barakat",
  },
  {
    identifier: "ar.khalidabdulkafi",
    name: "خالد عبد الخافي",
    englishName: "Khalid Abdulkhafi",
  },
  {
    identifier: "ar.khalidaljalil",
    name: "خالد الجليل",
    englishName: "Khalid Al Jalil",
  },
  {
    identifier: "ar.khalidalmohanna",
    name: "خالد المهنا",
    englishName: "Khalid Al-Moh'n'na",
  },
  {
    identifier: "ar.khalifaaltunaiji",
    name: "خليفة التنيجي",
    englishName: "Khalifah At-Tonaeijy",
  },
  {
    identifier: "ar.laayounelkouchi",
    name: "لعيون الكوشي",
    englishName: "Laayoun El Kouchi",
  },
  {
    identifier: "ar.lesaintcorantraduitenfrancais",
    name: "القرآن الكريم مترجم إلى الفرنسية",
    englishName: "Le Saint Coran Traduit En Francais",
  },
  {
    identifier: "ar.mahershakhashiro",
    name: "ماهر شخاشيرو",
    englishName: "Maher Shakhashero",
  },
  {
    identifier: "ar.mahmoodalrifai",
    name: "محمود الرفاعي",
    englishName: "Mahmod Alrifai",
  },
  {
    identifier: "ar.mahmoudalialbanna",
    name: "محمود علي البنا",
    englishName: "Mahmud Ali Al Banna",
  },
  {
    identifier: "ar.mahmoudelsheimy",
    name: "محمود الشيمي",
    englishName: "Mahmoud El Sheimy",
  },
  {
    identifier: "ar.mahmoudsaaddarouich",
    name: "محمود سعد الدرويش",
    englishName: "Mahmoud Saad Darouich",
  },
  {
    identifier: "ar.mahmoudsayedeltayeb",
    name: "محمود سيد الطيب",
    englishName: "Mahmoud Sayed Eltayeb",
  },
  {
    identifier: "ar.misharyrashidalafasy",
    name: "مشاري راشد العفاسي",
    englishName: "Mishary Rashid Alafasy",
  },
  {
    identifier: "ar.moeedhalharthi",
    name: "معيض الحارثي",
    englishName: "Moeedh Al-Harthi",
  },
  {
    identifier: "ar.mohamedabdelaziz",
    name: "محمد عبد العزيز",
    englishName: "Mohamed Abdelaziz",
  },
  {
    identifier: "ar.mohamedabdelhakimsaadalabdullah",
    name: "محمد عبد الحكيم سعد العبد الله",
    englishName: "Mohamed Abdel Hakim Saad Al Abdullah",
  },
  {
    identifier: "ar.mohamedaljaberyalheyani",
    name: "محمد الجابري الحياني",
    englishName: "Mohamed Aljabery Al Heyani",
  },
  {
    identifier: "ar.mohamedalmohisni",
    name: "محمد المحيسني",
    englishName: "Mohamed Al Mohisni",
  },
  {
    identifier: "ar.mohamedelkantaoui",
    name: "محمد القنطاوي",
    englishName: "Mohamed El Kantaoui",
  },
  {
    identifier: "ar.mohamedhassan",
    name: "محمد حسن",
    englishName: "Muhammad Hassan",
  },
  {
    identifier: "ar.mohamedmaabad",
    name: "محمد معبد",
    englishName: "Mohamed Maabad",
  },
  {
    identifier: "ar.mohamedosmankhan",
    name: "محمد عثمان خان (من الهند)",
    englishName: "Mohammed Osman Khan (from India)",
  },
  {
    identifier: "ar.mohamedshaabanabuqarn",
    name: "محمد شعبان أبو قرن",
    englishName: "Mohamed Shaaban Abu Qarn",
  },
  {
    identifier: "ar.mohamedtablawi",
    name: "محمد الطبلاوي",
    englishName: "Mohamed Al-Tablawi",
  },
  {
    identifier: "ar.mohammadismaeelalmuqaddim",
    name: "محمد إسماعيل المقدم",
    englishName: "Mohammad Ismaeel Al-Muqaddim",
  },
  {
    identifier: "ar.mohammadrachadalshareef",
    name: "محمد رشاد الشريف",
    englishName: "Mohammad Rachad Al Shareef",
  },
  {
    identifier: "ar.mohammedbinsalehabuzaid",
    name: "محمد بن صالح أبو زيد",
    englishName: "Mohammed Bin Saleh Abu Zaid",
  },
  {
    identifier: "ar.muftahalsaltany",
    name: "مفتاح السلطاني",
    englishName: "Moftah AlSultany",
  },
  {
    identifier: "ar.muhammadabdulkareem",
    name: "محمد عبد الكريم",
    englishName: "Muhammad AbdulKareem",
  },
  {
    identifier: "ar.muhammadalaalimaldokali",
    name: "محمد العالم الدكالي",
    englishName: "Muhammad Al Aalim Al Dokali",
  },
  {
    identifier: "ar.muhammadalluhaidan",
    name: "محمد الحيدان",
    englishName: "Mohammad Al-Haid'an",
  },
  {
    identifier: "ar.muhammadalmehysni",
    name: "محمد المحيسني",
    englishName: "Muhammad al-Muhaisny",
  },
  {
    identifier: "ar.muhammadalsubayyil",
    name: "محمد السبيل",
    englishName: "Muhammad Subbayil",
  },
  {
    identifier: "ar.muhammadanwarshahat",
    name: "محمد أنور شحات",
    englishName: "Muhammad Anwar Shahat",
  },
  {
    identifier: "ar.muhammadayyub",
    name: "محمد أيوب",
    englishName: "محمد أيوب",
  },
  {
    identifier: "ar.muhammadsalehalimshah",
    name: "محمد صالح شاه",
    englishName: "محمد صالح شاه",
  },
  {
    identifier: "ar.muhammadsiddiqalminshawimujawwad",
    name: "محمد صديق المنشاوي [مجود]",
    englishName: "محمد صديق المنشاوي [مجود]",
  },
  {
    identifier: "ar.muhammadsulaimanpatel",
    name: "محمد سليمان باتيل",
    englishName: "محمد سليمان باتيل",
  },
  {
    identifier: "ar.musabilal",
    name: "موسى بلال",
    englishName: "موسى بلال",
  },
  {
    identifier: "ar.mustafaallahouni",
    name: "مصطفى اللهوني",
    englishName: "مصطفى اللهوني",
  },
  {
    identifier: "ar.mustafaismail",
    name: "مصطفى إسماعيل",
    englishName: "مصطفى إسماعيل",
  },
  {
    identifier: "ar.mustafaraadalazzawi",
    name: "مصطفى رعد العزاوي",
    englishName: "مصطفى رعد العزاوي",
  },
  {
    identifier: "ar.mustaphagharbi",
    name: "مصطفى غربي",
    englishName: "مصطفى غربي",
  },
  {
    identifier: "ar.nabilarrifai",
    name: "نبيل الرفاعي",
    englishName: "نبيل الرفاعي",
  },
  {
    identifier: "ar.nasseralqatami",
    name: "ناصر القطامي",
    englishName: "ناصر القطامي",
  },
  {
    identifier: "ar.neamahalhassan",
    name: "نعمة الحسن",
    englishName: "نعمة الحسن",
  },
  {
    identifier: "ar.obeikan",
    name: "عبد المحسن العبيكان",
    englishName: "عبد المحسن العبيكان",
  },
  {
    identifier: "ar.oimaoqataris",
    name: "عميو قطريس",
    englishName: "عميو قطريس",
  },
  {
    identifier: "ar.omaralkazabri",
    name: "عمر القزابري",
    englishName: "عمر القزابري",
  },
  {
    identifier: "ar.osamabinalialghanim",
    name: "أسامة بن علي الغانم",
    englishName: "أسامة بن علي الغانم",
  },
  {
    identifier: "ar.rachidbelalia",
    name: "رشيد بالعلية",
    englishName: "رشيد بالعلية",
  },
  {
    identifier: "ar.saberabdulhakam",
    name: "صابر عبد الحكم",
    englishName: "صابر عبد الحكم",
  },
  {
    identifier: "ar.sadaqatali",
    name: "صداقت علي",
    englishName: "صداقت علي",
  },
  {
    identifier: "ar.sahlyasin",
    name: "سهل ياسين",
    englishName: "سهل ياسين",
  },
  {
    identifier: "ar.saidalshaalan",
    name: "سعيد الشعلان",
    englishName: "سعيد الشعلان",
  },
  {
    identifier: "ar.salahalbudair",
    name: "صلاح البدير",
    englishName: "صلاح البدير",
  },
  {
    identifier: "ar.salahalhashem",
    name: "صلاح الهاشم",
    englishName: "صلاح الهاشم",
  },
  {
    identifier: "ar.salahbaothman",
    name: "صلاح بن صالح بوعثمان",
    englishName: "صلاح بن صالح بوعثمان",
  },
  {
    identifier: "ar.samirbelaachya",
    name: "سمير بالعشية",
    englishName: "سمير بالعشية",
  },
  {
    identifier: "ar.saudalshuraim",
    name: "سعود الشريم",
    englishName: "سعود الشريم",
  },
  {
    identifier: "ar.sayedramadan",
    name: "الشيخ سيد رمضان",
    englishName: "Sheikh Syed Ramadan",
  },
  {
    identifier: "ar.shahriarparhizgar",
    name: "شهريار برهيزجار",
    englishName: "Shahriar Parhizgar",
  },
  {
    identifier: "ar.sudaisshuraymnaeemsultan",
    name: "الشيخ سديس والشيخ شريم مع نعيم سلطان [ترجمة بكثال]",
    englishName:
      "Shaykh Sudais and Shaykh Shuraim with Naeem Sultan [Pickthall Translation]",
  },
  {
    identifier: "ar.tamerislam",
    name: "تامر إسلام",
    englishName: "Tamer Islam",
  },
  {
    identifier: "ar.tareqabdulganidaawob",
    name: "طارق داووب",
    englishName: "Tareq Daawob",
  },
  {
    identifier: "ar.tawfeeqassayegh",
    name: "توفيق الصايغ",
    englishName: "Tawfeeq As-Sayegh",
  },
  {
    identifier: "ar.turkiebeidalmarri",
    name: "تركي عبيد المري",
    englishName: "Turki Ebeid Al Marri",
  },
  {
    identifier: "ar.waeldesouky",
    name: "وائل الدسوقي",
    englishName: "Wael Desouky",
  },
  {
    identifier: "ar.waelradwanqureshi",
    name: "وائل رضوان قريشي",
    englishName: "Wael Radwan Qureshi",
  },
  {
    identifier: "ar.waleedidreesalmaneese",
    name: "وليد إدريس المنيسي",
    englishName: "Waleed Idrees Al Maneese",
  },
  {
    identifier: "ar.waleednaehi",
    name: "وليد النائحي",
    englishName: "Waleed AlNa'ehi",
  },
  {
    identifier: "ar.waleedsamiraliabdulmajidsorour",
    name: "وليد سمير علي عبد المجيد سرور",
    englishName: "Waleed Samir Ali Abdul Majid Sorour",
  },
  {
    identifier: "ar.walidalshatti",
    name: "وليد الشطي",
    englishName: "Walid Al Shatti",
  },
  {
    identifier: "ar.walidfathibashta",
    name: "وليد فتحي بشتا",
    englishName: "Walid Fathi Bashta",
  },
  {
    identifier: "ar.yahyahawwa",
    name: "يحيى حوى",
    englishName: "Yahya Hawwa",
  },
  {
    identifier: "ar.yassenaljazairi",
    name: "ياسين الجزائري",
    englishName: "Yassen Al Jazairi",
  },
  {
    identifier: "ar.yasseraldossari",
    name: "ياسر الدوسري",
    englishName: "Yasser Al_Dosari",
  },
  {
    identifier: "ar.yasseralmazroyee",
    name: "ياسر المزروعي",
    englishName: "Yasser Al-Mazroey",
  },
  {
    identifier: "ar.yasserqureshi",
    name: "ياسر الكرشي",
    englishName: "Yasser AlKurashy",
  },
  {
    identifier: "ar.yassersalama",
    name: "ياسر سلامة",
    englishName: "Yasser Salama",
  },
  {
    identifier: "ar.yassersarhaneldeeb",
    name: "ياسر سرحان الديب",
    englishName: "Yasser Sarhan Eldeeb",
  },
  {
    identifier: "ar.yousufalshoaey",
    name: "يوسف الشويعي",
    englishName: "Yousef Al-Shoowayie'e",
  },
  {
    identifier: "ar.yousufbinnoahahmad",
    name: "يوسف بن نوح أحمد",
    englishName: "Yusuf Bin Noah Ahmed",
  },
  {
    identifier: "en.misharyrashidalafasyenglishtranslationsaheehibrahimwalk",
    name: "مشاري العفاسي مع إبراهيم واك [ترجمة سعيد حليب]",
    englishName: "Mishaari Raashid with Ibrahim Walk [Saheeh Intl Translation]",
  },
  {
    identifier: "en.muhammadayyubenglishtranslationmuhsinkhanmikaalwaters",
    name: "محمد أيوب مع ميكال واترز [ترجمة محسن خان]",
    englishName: "Muhammad Ayoob with Mikaal Waters [Muhsin Khan Translation]",
  },
  {
    identifier: "en.sudaisandshuraymenglishtranslationpickthallaslamathar",
    name: "سديس وشريم مع أسلم أثر [ترجمة بكثال]",
    englishName: "Sodais and Shuraim with Aslam Athar [Pickthall Translation]",
  },
];

export default SurahReader;
